<template>
  <div class="cashier-container" :class="{ 'cashier-container-close': !isToggleOpen }" ref="cashierContainerRef" v-loading="loading">
    <div class="cashier-container-l">
      <div class="cashier-container-l-content">
        <h6>
          <span>票据抽屉</span>
        </h6>

        <div>
          <el-scrollbar always>
            <ul>
              <li v-for="(item, index) of cashierList" :key="index" :class="{ 'is-select': isSelect(item) }" @click="cashierSelect(item)">
                <p>{{ item.name }}</p>
                <span class="tag">{{ cashierListSelectIndex(item) }}</span>
              </li>
            </ul>
          </el-scrollbar>
        </div>

        <section>
          <div class="tag">{{ cashierListSelect.length }}</div>
          <span>确定选择</span>
        </section>
      </div>

      <div class="toggle-btn" @click="toggle">
        <el-icon color="#ffffff">
          <ArrowLeft v-show="isToggleOpen" />
          <ArrowRight v-show="!isToggleOpen" />
        </el-icon>
      </div>
    </div>

    <div class="cashier-container-r">
      <div class="is-empty" v-show="!cashierListSelect.length">
        <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-03-29/1743237879538_1743237792587.jpg" />
      </div>

      <div class="cashier-content">
        <div class="cashier-select">
          <el-scrollbar always>
            <ul>
              <li v-for="(item, index) of cashierListSelect" :key="index" :class="{ 'is-active': cashierSelectActiveIndex == index }" @click="cashierSelectActive(index)">
                {{ item.name }}

                <div class="btn-del" @click.stop="cashierDelete(item, index)">
                  <el-icon><Close /></el-icon>
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </div>

        <div class="cashier-que">
          <el-scrollbar always>
            <section class="cashier-main" :class="{ toolClick3active: toolClick3active }">
              <section class="invoice-tool">
                <span>{{ cashierSelectActived?.name }}</span>

                <ul>
                  <li @click="toolClick1('√')">√‌勾</li>
                  <li @click="toolClick1('¥')">¥人民币符号</li>
                  <li @click="toolClick1('ⓧ')">ⓧ封闭符号</li>
                  <li @click="toolClick2(0)">
                    <el-icon><DeleteFilled /></el-icon>删除划线
                  </li>
                  <li @click="toolClick2(2)">
                    <el-icon><EditPen /></el-icon>划红线
                  </li>
                  <li @click="toolClick2(1)">
                    <el-icon><EditPen /></el-icon>划线
                  </li>
                  <li class="toolClick3" @click="toolClick3(3)">
                    <el-icon><EditPen /></el-icon>划斜线
                  </li>
                </ul>
              </section>
              <section class="invoice-wrap" :class="`invoice-wrap-${cashierSelectActived?.id}`"></section>
              <section class="invoice-btn">
                <el-button type="primary" plain @click="redo">
                  <el-icon><RefreshRight /></el-icon>
                  <span>重新做题</span>
                </el-button>
                <el-button type="primary" @click="submit">
                  <el-icon><Document /></el-icon>
                  <span>提交答案</span>
                </el-button>
              </section>
            </section>
          </el-scrollbar>
        </div>
      </div>
    </div>

    <!-- 印章 -->
    <el-dialog
      class="seal-popup"
      align-center
      v-model="dialogVisibleSeal"
      title="选择印章"
      width="600"
      destroy-on-close
      @closed="sealPopupClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model.trim="sealSearchText" placeholder="输入关键字进行搜索" clearable />
      <div class="seal-popup-content">
        <div class="seal-list-empty" v-if="tsmListSearch.length == 0">
          <el-empty :image-size="200" description="暂无数据" />
        </div>
        <el-scrollbar always>
          <ul class="seal-list">
            <li v-for="(item, index) of tsmListSearch" :key="index" :class="{ 'is-selected': selectSealItem.id == item.id }">
              <el-image :src="item.seaL_URL" fit="contain" @click="selectSeal(item)" />
            </li>
          </ul>
        </el-scrollbar>
      </div>

      <div class="seal-popup-footer">
        <el-button type="primary" @click="sealPopupConfirm">确认</el-button>
        <el-button @click="sealPopupCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup name="CashierQuestionManager">
import Big from "big.js";
import axios from "axios";
import { cloneDeep } from "lodash";
import { getInvlist, getTSMList } from "@/api/cashier/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
import { computed, onBeforeMount, toRaw } from "vue";
import { $emit, $on } from "vue-happy-bus";
import { htmlEdit } from "./utils.js";

const getGrandchildValue = inject("getGrandchildValue");

const props = defineProps({
  currentQa: {
    // 当前题目信息对象
    required: true,
    type: Object,
  },
});

const answer = computed(() => {
  try {
    return JSON.parse(props.currentQa.answer);
  } catch (e) {
    return [];
  }
});

const answerId = computed(() => {
  return answer.value.map(({ id }) => id);
});

const route = useRoute();
const router = useRouter();
const isDev = ref(import.meta.env.DEV);
const { proxy } = getCurrentInstance();
const { id } = route.query;

// 已选票据
const cashierListSelect = ref([]);

const cashierSelect = (item) => {
  if (!answerId.value.includes(item.id)) {
    ElMessage.error("请选择正确的票据");
    return;
  }

  const findIndex = isSelectIndex(item);

  if (findIndex > -1) {
    cashierDelete(item);
  } else {
    cashierListSelect.value.push(cloneDeep(item));
  }
};

const cashierDelete = (item) => {
  ElMessageBox.confirm("确认删除此张票据", "提示").then(() => {
    const findIndex = isSelectIndex(item);
    const cashierListSelectLength = cashierListSelect.value.length;

    if (findIndex < cashierSelectActiveIndex.value) {
      cashierSelectActiveIndex.value = cashierSelectActiveIndex.value - 1;
    } else if (findIndex == cashierSelectActiveIndex.value) {
      if (findIndex == 0) {
      } else if (findIndex == cashierListSelectLength - 1) {
        cashierSelectActiveIndex.value = cashierSelectActiveIndex.value - 1;
      }
    }

    cashierListSelect.value.splice(findIndex, 1);
    deleteSyncSave(item);
  });
};

const isSelectIndex = (item) => {
  const findIndex = cashierListSelect.value.findIndex(({ id }) => id == item.id);

  return findIndex;
};

const isIndex = (item) => {
  const findIndex = cashierList.value.findIndex(({ id }) => id == item.id);

  return findIndex;
};

const isSelect = (item) => {
  return isSelectIndex(item) > -1;
};

const cashierListSelectIndex = (item) => {
  const findIndex = isSelectIndex(item);

  if (findIndex == -1) {
    return "";
  }

  return findIndex + 1;
};

const cashierSelectActiveIndex = ref(0);
const cashierSelectActive = (index) => {
  if (cashierSelectActiveIndex.value != index) {
    cashierSelectActiveIndex.value = index;
  }
};

const cashierSelectActived = computed(() => {
  return cashierListSelect.value[cashierSelectActiveIndex.value];
});

watch(cashierSelectActived, (newVal, oldVal) => {
  cashierSelectActivedInit(newVal, oldVal);
});

const cashierSelectActivedInit = async (newVal, oldVal) => {
  toolClick3active.value = false;
  // console.log(newVal, oldVal);
  // 切换之前的节点
  if (oldVal) {
    const findIndex = isSelectIndex(oldVal);

    if (findIndex > -1) {
      // 如果节点还存在已选列表中 没有被删除
      const $billContent = $(".billContent_html");
      const html = $billContent.prop("outerHTML");
      const inputValue = [...$billContent.find("input, textarea").map((index, ele) => $(ele).val())];
      const sealValue = Array.from(
        $(".invoice-wrap .seal").map((index, item) => {
          return $(item).data("sealData") || "";
        })
      );

      const cashierData = {
        html: encodeURIComponent(html),
        inputValue,
        sealValue,
      };
      console.log("保存数据", cashierData);
      cashierListSelect.value[findIndex].cashierData = cashierData;
    }
  }

  // 切换之后的节点
  if (newVal) {
    // 看配置列表中节点有没有数据 没有先补足配置列表
    const findIndex = isIndex(newVal);
    if (!cashierList.value[findIndex].cashierData) {
      const cashierData = {
        html: encodeURIComponent((await axios.get(newVal.url)).data),
        inputValue: [],
        sealValue: [],
      };

      cashierList.value[findIndex].cashierData = cashierData;
    }

    // 当前选中节点没有数据
    if (!newVal.cashierData) {
      // 更新到当前节点html
      cashierListSelect.value[cashierSelectActiveIndex.value].cashierData = cloneDeep(cashierList.value[findIndex].cashierData);
    }

    // 获取票据数据
    const { html, inputValue, sealValue } = newVal.cashierData;
    console.log("恢复数据", newVal.cashierData);

    // 渲染票据
    $(".invoice-wrap").html(htmlEdit(decodeURIComponent(html)));
    const $billContent = $(".billContent_html");
    inputValue.forEach((val, index) => {
      $billContent.find("input, textarea").eq(index).val(val);
    });
    sealValue.forEach((val, index) => {
      $billContent.find(".seal").eq(index).data("sealData", val);
    });
    // 印章显示/选择/删除
    sealToolsInit();
    // 画板
    drawToolsInit(newVal.drawLineData);
  }
};

// 重新做题
const redo = () => {
  toolClick3active.value = false;
  const findIndex = isIndex(cashierSelectActived.value);
  // 配置列表中节点数据 获取更新到当前节点html
  cashierListSelect.value[cashierSelectActiveIndex.value].cashierData = cloneDeep(cashierList.value[findIndex].cashierData);
  cashierListSelect.value[cashierSelectActiveIndex.value].drawLineData = null;
  // 获取票据数据
  const { html, inputValue, sealValue } = cashierListSelect.value[cashierSelectActiveIndex.value].cashierData;
  console.log("恢复数据", cashierListSelect.value[cashierSelectActiveIndex.value].cashierData);

  // 渲染票据
  $(".invoice-wrap").html(htmlEdit(decodeURIComponent(html)));
  const $billContent = $(".billContent_html");
  inputValue.forEach((val, index) => {
    $billContent.find("input, textarea").eq(index).val(val);
  });
  sealValue.forEach((val, index) => {
    $billContent.find(".seal").eq(index).data("sealData", val);
  });
  // 印章显示/选择/删除
  sealToolsInit();
  // 画板
  drawToolsInit();
};

// 印章显示/选择/删除
function sealToolsInit() {
  $(".invoice-wrap .one.seal").each(function () {
    const $this = $(this);

    if (!$this.find(".seal-tools-select")[0]) {
      $this.append(
        `
        <div class="seal-tools-img"><img src="" /></div>
        <span class="seal-tools-select">选择印章</span>
        <span class="seal-tools-del">x</span>
      `
      );
    }
  });
}

// 画板
// 费用报销单 入库单
const drawList = ["c5985cd1b95a4851b30f2dba23d7685b", "99e8a2b7e68248da9a34254a67400b42"];
function drawToolsInit(drawLineData) {
  nextTick(() => {
    const $billContent_html = $(`.invoice-wrap .billContent_html`);
    // const $billContent_html = $(`.invoice-wrap-${id} .billContent_html`);

    if ($billContent_html[0] && !$billContent_html.find(".draw-tools")[0]) {
      $billContent_html.append(
        `<div class="draw-tools">
            <div class="canvas-layer"></div>
            <canvas></canvas>
          </div>`
      );
    }

    if (drawLineData) {
      const { canvasWidth, canvasHeight, startX, startY, endX, endY } = drawLineData;
      const canvas = $billContent_html.find("canvas").get(0);
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const ctx = canvas.getContext("2d");
      drawLine(ctx, { startX, startY, endX, endY });
    }
  });
}

// 侧边栏收起
const isToggleOpen = ref(true);
const toggle = () => {
  isToggleOpen.value = !isToggleOpen.value;
};

const cashierContainerRef = ref();
const setHeight = () => {
  const $el = cashierContainerRef.value;
  $el.style.height = `calc(100vh - ${$el.getBoundingClientRect().top}px - 10px)`;
};

const loading = ref(false);
const tsmList = ref([]);
const solutionData = ref([]);
const init = async () => {
  loading.value = true;

  try {
    const getInvlistRes = await getInvlist(); // 获取出纳列表
    const getTSMListRes = await getTSMList(); // 发票印章

    const tsmListIds = [
      "a2e96c4c1b394f8c90893522b7ddfec2",
      "042e5d5765af4921a002034f2a56c55b",
      "33e906b8e6e04ff999caaef709086dfa",
      "303c7276accf4cc3b91c859966456288",
      "59c57b336c124f95adc47186b5349a36",
      "1eb36f76f7e946c8a1fa0ffdda28bfda",
      "2ad30d0543d1476cb1d0e776c5bb041c",
      "93fcdcd05c8c4a94928b4aea5196024b",
      "f4e5cffa53ce4ca3a2b9367b1c9be327",
    ];
    // 取出纳印章
    tsmList.value = getTSMListRes.data.data.list.filter((item) => tsmListIds.includes(item.id));

    getInvlistRes.data.data.list.forEach((item) => {
      const findIndex = cashierList.value.findIndex(({ id }) => id == item.id);

      if (findIndex > -1) {
        cashierList.value[findIndex] = Object.assign({}, cashierList.value[findIndex], cloneDeep(item));
      }
    });

    const data = (props.currentQa.solution && JSON.parse(props.currentQa.solution)) || [];

    console.log("获取数据", data);
    solutionData.value = data;
    // 更新到已选列表
    cashierListSelect.value = data.map((item) => {
      const mathItem = cashierList.value.find(({ id }) => item.id == id);

      const { cashierData, drawLineData } = item;

      return {
        ...cloneDeep(mathItem),
        cashierData,
        drawLineData,
      };
    });
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  setHeight();
  sealFnInit();
  drawFnInit();
  init();
});

onBeforeMount(() => {
  $(document).off("mousedown.draw mousemove.draw mouseup.draw");
});

// 配置
const cashierList = ref([
  {
    id: "e94423edab19469595fe2cd72127c798",
    name: "资金申请表（rh）",
  },
  {
    id: "12bb6c8c12614b21b1c7832046fc14e7",
    name: "借支单（rh）",
  },
  {
    id: "c5985cd1b95a4851b30f2dba23d7685b",
    name: "费用报销单（rh）",
  },
  {
    id: "9c81fa97105f4719856f3f8e5ce11f57",
    name: "差旅费报销单（rh）",
  },
  {
    id: "42f46e1ae6654b6db41ab48633a52565",
    name: "收据（rh）",
  },
  {
    id: "252da66a618047dea87bf2ce825dafa0",
    name: "资金日报表（rh）",
  },
  {
    id: "99e8a2b7e68248da9a34254a67400b42",
    name: "入库单（rh）",
  },
  {
    id: "71f584f9607a45218400a1264f37b611",
    name: "出库单（rh）",
  },
  {
    id: "c8a1be6de92546b884895e820d4e679c",
    name: "现金交款单",
  },
  {
    id: "1691d0500b7348df8923b5a13de53fa4",
    name: "现金支票正面",
  },
  {
    id: "5a43a604d2c542678577c42d38353587",
    name: "现金支票反面",
  },
  {
    id: "cd5f8b3f7e9a434bbaa2c5be046043e5",
    name: "转账支票正面",
  },
  {
    id: "cdb022f655264c01b9ecc1d66213bba6",
    name: "转账支票反面",
  },
  {
    id: "4b270ff6ada9487fbad6f921055fd0f2",
    name: "库存现金盘点表",
  },
  {
    id: "9706958b5fd747d3a4b0e2964bb2a328",
    name: "库存现金日记账",
  },
  {
    id: "16df9ed1a2fc44f7bc9fc27acdce069f",
    name: "银行存款日记账",
  },
]);

// 当前印章
let $seal = null;
function sealFnInit() {
  let outClass = ".invoice-wrap .billContent_html";

  // drag
  let dragX = 0;
  let dragY = 0;
  let $drag = null;
  let dragClass = ".seal";
  // resize
  let resizeX = 0;
  let resizeY = 0;
  let $resize = null;
  let resizeClass = ".seal .span";

  // 印章拖拽与修改大小
  /* $(document)
    .off("mousedown.invoiceTool.drag mousedown.invoiceTool.resize mousemove.invoiceTool mouseup.invoiceTool")
    .on("mousedown.invoiceTool.drag", `${outClass} ${dragClass}`, function (e) {
      console.log("mousedown.invoiceTool.drag");

      const $this = $(this);
      $this.data("zIndex", $this.css("z-index"));
      $this.css("zIndex", 9999);
      dragX = e.pageX - $this.offset().left;
      dragY = e.pageY - $this.offset().top;
      $drag = $this;

      return false;
    })
    .on("mousedown.invoiceTool.resize", `${outClass} ${resizeClass}`, function (e) {
      console.log("mousedown.invoiceTool.resize");

      const $this = $(this);
      resizeX = e.pageX;
      resizeY = e.pageY;
      $resize = $this.closest(dragClass);
      $resize.data("width", $resize.outerWidth());
      $resize.data("height", $resize.outerHeight());

      return false;
    })
    .on("mousemove.invoiceTool", function (e) {
      if (!$drag && !$resize) {
        return false;
      }

      // console.log("mousemove.invoiceTool");

      if ($drag) {
        const $out = $drag.closest(outClass);

        $drag.css({
          left: e.pageX - $out.offset().left - dragX,
          top: e.pageY - $out.offset().top - dragY,
        });
      }

      if ($resize) {
        $resize.css("width", Math.max($resize.data("width") + e.pageX - resizeX, 20));
        $resize.css("height", Math.max($resize.data("height") + e.pageY - resizeY, 20));
      }

      return false;
    })
    .on("mouseup.invoiceTool", function () {
      if (!$drag && !$resize) {
        return false;
      }

      console.log("mouseup.invoiceTool");

      if ($drag) {
        $drag.css("zIndex", $drag.data("zIndex"));
        dragX = 0;
        dragY = 0;
        $drag = null;
      }

      if ($resize) {
        resizeX = 0;
        resizeY = 0;
        $resize = null;
      }

      return false;
    }); */

  // 印章选择与删除
  let selectClass = ".seal-tools-select";
  let delClass = ".seal-tools-del";
  $(document)
    .off("mousedown.invoiceTool.seal-tools click.invoiceTool.seal-tools-select click.invoiceTool.seal-tools-del")
    .on("mousedown.invoiceTool.seal-tools", `${outClass} ${selectClass}, ${outClass} ${delClass}`, function (e) {
      return false;
    })
    .on("click.invoiceTool.seal-tools-select", `${outClass} ${selectClass}`, function (e) {
      dialogVisibleSeal.value = true;
      $seal = $(this).closest(dragClass);
      return false;
    })
    .on("click.invoiceTool.seal-tools-del", `${outClass} ${delClass}`, function (e) {
      $seal = $(this).closest(dragClass);

      $seal.find(".seal-tools-img img").attr("src", "");
      $seal.data("sealData", "");
      $seal.removeClass("is-selected");
      $seal = null;

      return false;
    });
}

// 印章选择弹窗
const selectSealItem = ref({});
const dialogVisibleSeal = ref(false);
const sealSearchText = ref("");
const tsmListSearch = computed(() => {
  selectSealItem.value = {};

  if (sealSearchText.value == "") {
    return tsmList.value;
  }

  return tsmList.value.filter((item) => item.seaL_NAME.includes(sealSearchText.value));
});

const selectSeal = (item) => {
  selectSealItem.value = item;
};
const sealPopupConfirm = () => {
  if (Object.values(selectSealItem.value).length == 0) {
    ElMessage.error("请选择印章");
    return;
  }

  $seal.find(".seal-tools-img img").attr("src", selectSealItem.value.seaL_URL);
  $seal.data("sealData", selectSealItem.value.id);
  $seal.addClass("is-selected");
  $seal = null;

  sealPopupCancel();
};
const sealPopupCancel = () => {
  dialogVisibleSeal.value = false;
};
const sealPopupClose = () => {
  selectSealItem.value = {};
  sealSearchText.value = "";
};

// 画板
function drawFnInit() {
  let startX, startY, endX, endY;
  let canvas = null;
  let ctx = null;

  $(document).on("mousedown.draw", "canvas", function (e) {
    canvas = e.target;
    canvas.width = $(canvas).width();
    canvas.height = $(canvas).height();
    ctx = canvas.getContext("2d");
    startX = e.offsetX;
    startY = e.offsetY;
    endX = e.offsetX;
    endY = e.offsetY;
  });

  $(document).on("mousemove.draw", function (e) {
    if (canvas) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      endX = e.offsetX;
      endY = e.offsetY;
      drawLine(ctx, { startX, startY, endX, endY });
    }
  });

  $(document).on("mouseup.draw", function (e) {
    if (canvas) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawLine(ctx, { startX, startY, endX, endY });
      drawLineDone({
        canvas,
        startX,
        startY,
        endX,
        endY,
      });
      canvas = null;
      ctx = null;
    }
  });
}

// 划线
function drawLine(ctx, { startX, startY, endX, endY }) {
  ctx.strokeStyle = "#666666";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(startX, startY);
  ctx.lineTo(endX, endY);
  ctx.stroke();
}

// 划线结束
function drawLineDone({ canvas, startX, startY, endX, endY }) {
  cashierListSelect.value[cashierSelectActiveIndex.value].drawLineData = {
    canvasWidth: canvas.width,
    canvasHeight: canvas.height,
    startX,
    startY,
    endX,
    endY,
  };
}

// 工具
$(document).on("focus", "input, textarea", function (e) {
  $toolClickFocus = $(this);
});

let $toolClickFocus = null;
const toolClick1 = (text) => {
  if ($toolClickFocus) {
    $toolClickFocus.val(`${$toolClickFocus.val()}${text}`);
    // $toolClickFocus = null;
  }
};

const toolClick2 = (type) => {
  if ($toolClickFocus) {
    if (type == 1) {
      $toolClickFocus.css({
        "text-decoration": "line-through",
        "text-decoration-color": "unset",
      });
    }

    if (type == 2) {
      $toolClickFocus.css({
        "text-decoration": "line-through",
        "text-decoration-color": "red",
      });
    }

    if (type == 0) {
      $toolClickFocus.css({
        "text-decoration": "none",
        "text-decoration-color": "unset",
      });
    }

    // $toolClickFocus = null;
  }
};

const toolClick3active = ref(false);
const toolClick3 = () => {
  toolClick3active.value = !toolClick3active.value;
};

// 保存方式
const saveType = ref(null);
// 删除时同步保存
const deleteSyncSave = async (item) => {
  const findIndex = solutionData.value.findIndex((solutionDataItem) => solutionDataItem.id == item.id);

  if (findIndex > -1) {
    solutionData.value.splice(findIndex, 1);

    const solution = cloneDeep(toRaw(solutionData.value));

    console.log("删除同步提交数据", solution);
    getGrandchildValue.value.getData = () => {
      return {
        solution: JSON.stringify(solution),
      };
    };

    getGrandchildValue.value.fillFinish = () => {
      // todo 根据老师答案与学员做题数据判断学员是否做完
      // 老师数据长度 != 学员数据长度 未完成
      // 老师数据id != 学员数据id 未完成
      // 学员数据仁和一条缺少cashierData 未完成

      // todo 学员删除已选时 同步数据
      return true;
    };

    saveType.value = 0;
    $emit("exeSaveQa");
  }
};

// 保存
const submit = async () => {
  // 保存当前
  const findIndex = isSelectIndex(cashierSelectActived.value);

  if (findIndex > -1) {
    // 如果节点还存在已选列表中 没有被删除
    const $billContent = $(".billContent_html");
    const html = $billContent.prop("outerHTML");
    const inputValue = [...$billContent.find("input, textarea").map((index, ele) => $(ele).val())];
    const sealValue = Array.from(
      $(".invoice-wrap .seal").map((index, item) => {
        return $(item).data("sealData") || "";
      })
    );

    const cashierData = {
      html: encodeURIComponent(html),
      inputValue,
      sealValue,
    };
    console.log("保存数据", cashierData);
    cashierListSelect.value[findIndex].cashierData = cashierData;
  }

  // 学员答题数据
  const { inputValue: inputValueStu, sealValue: sealValueStu } = cashierSelectActived.value.cashierData;
  // 对应老师答案
  const answerActived = answer.value.find(({ id }) => id == cashierSelectActived.value.id);
  const { inputValue, sealValue } = answerActived.cashierData;
  let isCheck = true;
  // 输入框与印章验证
  [inputValue, sealValue].forEach((item, index) => {
    item.forEach((it, idx) => {
      const value = index == 0 ? inputValueStu[idx] : sealValueStu[idx];
      const ele = index == 0 ? "input, textarea" : ".seal";

      if (it.trim() == value.trim()) {
        $(`.invoice-wrap ${ele}`).eq(idx).closest(".one").removeClass("is-error");
      } else {
        $(`.invoice-wrap ${ele}`).eq(idx).closest(".one").addClass("is-error");
        isCheck = false;
      }
    });
  });

  if (!isCheck) {
    ElMessageBox.alert("您的答案有误，请查看红框提示！", "信息", { type: "error" });
  } else {
    ElMessageBox.alert("恭喜您！全部正确！", "信息", { type: "success" });
  }

  const solution = cloneDeep(
    cashierListSelect.value.map(({ id, name, cashierData, drawLineData }) => {
      const cashierDataClone = cloneDeep(cashierData);

      if (cashierDataClone && cashierDataClone.html) {
        // 有数据
        const $html = $(decodeURIComponent(cashierDataClone.html));

        if (id == "c8a1be6de92546b884895e820d4e679c") {
          // 现金缴款单设置成第一联
          const bgImg = [
            "https://static.rhkj.com/renhe_fe/other/invoiceTool/invT_s/1GocQc60K5220720045149061.png",
            "https://static.rhkj.com/renhe_fe/other/invoiceTool/invT_s/1GocQc60K5220720045149061_2.jpg",
          ];

          $html.find(".JointSessionItem").eq(0).addClass("active").siblings().removeClass("active");
          $html.find(".billImg").attr("src", bgImg[0]);
        }

        // 去除is-error
        $html.find(".is-error").removeClass("is-error");
        cashierDataClone.html = encodeURIComponent($html.prop("outerHTML"));
      }

      return {
        id,
        name,
        cashierData: cashierDataClone,
        drawLineData,
      };
    })
  );
  console.log("提交数据", solution);
  getGrandchildValue.value.getData = () => {
    return {
      solution: JSON.stringify(solution),
    };
  };

  getGrandchildValue.value.fillFinish = () => {
    // todo 根据老师答案与学员做题数据判断学员是否做完
    // 老师数据长度 != 学员数据长度 未完成
    // 老师数据id != 学员数据id 未完成
    // 学员数据仁和一条缺少cashierData 未完成

    // todo 学员删除已选时 同步数据
    return true;
  };

  saveType.value = 1;
  $emit("exeSaveQa");
  solutionData.value = solution;
};

getGrandchildValue.value.getResetData = () => {
  return {
    solution: "",
  };
};

// 保存成功回调
$on("saveQaSuccess", (res) => {
  if (saveType.value == 1) {
    ElMessage.success("提交成功");
    saveType.value == null;
  }
});

// 现金交款单
$(document).on("click", ".invoice-wrap-c8a1be6de92546b884895e820d4e679c .JointSession .JointSessionItem", function () {
  const $this = $(this);
  const index = $this.index();
  const bgImg = [
    "https://static.rhkj.com/renhe_fe/other/invoiceTool/invT_s/1GocQc60K5220720045149061.png",
    "https://static.rhkj.com/renhe_fe/other/invoiceTool/invT_s/1GocQc60K5220720045149061_2.jpg",
  ];

  if (!$this.hasClass("active")) {
    $this.addClass("active");
    $this.siblings().removeClass("active");
    $this.closest(".invoice-wrap").find(".billImg").attr("src", bgImg[index]);
  }
});
</script>

<style scoped lang="scss">
.cashier-container {
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 14px;
  line-height: 1.5;

  :deep(.is-error) {
    background-color: #ff8c8c !important;
  }

  &.cashier-container-close {
    .cashier-container-l {
      width: 0;

      .cashier-container-l-content {
        display: none;
      }
    }
  }

  .cashier-container-l {
    width: 250px;
    flex: 0 0 auto;
    position: relative;
    z-index: 2;
    height: 100%;

    .cashier-container-l-content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      > h6 {
        text-align: center;
        font-size: 18px;
        color: #666666;
        flex: 0 0 auto;
        overflow: hidden;
        position: relative;
        height: 52px;
        box-sizing: border-box;
        padding: 10px 5px;
        display: flex;
        justify-content: space-between;

        > span {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      > div {
        width: 100%;
        height: 100%;
        overflow: hidden;
        font-size: 15px;

        ul {
          padding: 0 14px 0 8px;

          li {
            padding: 8px 0;
            border-bottom: 1px solid #e5e5e5;
            cursor: pointer;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &.is-select {
              span {
                background-color: #3f8dfd;
                border-color: #3f8dfd;
                color: #ffffff;
              }
            }

            span {
              width: 21px;
              height: 21px;
              border: 1px solid #cccccc;
              box-sizing: border-box;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: Arial, Helvetica, sans-serif;
              font-size: 12px;
            }
          }
        }
      }

      > section {
        margin-top: 40px;
        height: 50px;
        flex: 0 0 auto;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #3f8dfd;
        color: #ffffff;
        cursor: pointer;

        .tag {
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f56c6c;
          border-radius: 50%;
          font-size: 12px;
          margin-right: 8px;
          font-family: Arial, Helvetica, sans-serif;
        }
      }
    }

    .toggle-btn {
      position: absolute;
      width: 18px;
      height: 56px;
      background-color: #3f8dfd;
      cursor: pointer;
      top: 50%;
      right: 0;
      transform: translate(100%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .cashier-container-r {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #e3e3e3;
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    border-left: 2px solid #e3e3e3;

    .is-empty {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      box-sizing: border-box;
      padding: 30px 0 0 30px;
      background-color: #e3e3e3;
      z-index: 99;
    }

    .cashier-content {
      height: 100%;
      display: flex;
      flex-direction: column;

      .cashier-select {
        width: 100%;
        flex: 0 0 auto;
        background-color: #e2e6ee;
        border-top: 1px solid #d8dce5;
        border-bottom: 1px solid #d8dce5;

        ul {
          display: flex;

          li {
            flex-shrink: 0;
            height: 46px;
            color: #878d98;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 25px;
            cursor: pointer;
            border-right: 1px solid #d8dce5;
            position: relative;

            &.is-active {
              background-color: #ffffff;
              color: #3f8dfd;
            }

            .btn-del {
              position: absolute;
              right: 5px;
              top: 50%;
              transform: translateY(-50%);
              display: flex;
              justify-content: center;
              align-items: center;
              width: 20px;
              height: 20px;
            }
          }
        }
      }

      .cashier-que {
        width: 100%;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        padding: 25px;

        .cashier-main {
          display: inline-flex;
          flex-direction: column;
          background-color: #f5f5f5;

          .invoice-tool {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 45px;
            padding: 0 15px;
            color: #666666;

            ul {
              display: flex;

              li {
                cursor: pointer;
                display: flex;
                align-items: center;
                padding: 0 8px;
                margin: 0 2px;
              }
            }
          }

          .invoice-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;
          }
        }
      }
    }
  }

  :deep(.invoice-wrap) {
    .span {
      display: none;
    }

    .svg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    * {
      margin: 0;
      padding: 0;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    .water-mark {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      left: 0;
      top: 0;
      overflow: hidden;
      background: url(https://static.rhkj.com/renhe_fe/other/347.png) repeat;
      background-size: 50%;
      visibility: hidden;
    }

    .one:not(.Password) p {
      display: none;
    }

    .one {
      &.seal {
        z-index: 1999 !important;

        &.is-selected {
          .seal-tools-select {
            display: none;
          }

          .seal-tools-del {
            display: flex;
          }
        }

        .seal-tools-img {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            max-width: 100%;
            max-height: 100%;
          }
        }

        .seal-tools-select,
        .seal-tools-del {
          white-space: nowrap;
          position: absolute;
          z-index: 10;
          cursor: pointer;
          line-height: 1;
          font-size: 14px;
          background-color: rgba(#e2322a, 0.6);
          color: #ffffff;
          overflow: hidden;
        }

        .seal-tools-select {
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #ffffff;
          padding: 5px !important;
        }

        .seal-tools-del {
          top: 0;
          right: 0;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: Arial, Helvetica, sans-serif;
          font-size: 16px;
          display: none;
        }
      }
    }
    .billContent_html {
      z-index: 5;
    }
    .billContent_html * {
      outline: none;
    }
    .billContent_html .Beginning {
      background: #52b8e5;
      position: absolute;
      top: 0px;
      right: 0px;
      width: 10px;
      height: 10px;
      border-radius: 10px;
    }
    .billContent_html .NoJudgment {
      background: #ea6d45;
      position: absolute;
      top: 0px;
      right: 10px;
      width: 10px;
      height: 10px;
      border-radius: 10px;
    }
    .billContent_html table tr td {
      position: relative;
    }
    .billContent_html table tr td input {
      width: 100%;
    }
    .billContent_html table tr td .input.active {
      border: 1px solid red;
    }
    .billContent_html table tr td .active2 {
      border: 1px solid #6490ed;
    }
    .billContent_html table tr td .input.active2 {
      border: 1px solid #6490ed;
    }
    .billContent_html table tr td input[type="radio"],
    .billContent_html table tr td input[type="checkbox"] {
      width: auto;
      display: block;
    }
    .billContent_html .JointSession {
      position: absolute;
      top: 0;
      left: 830px;
      white-space: nowrap;
    }
    .billContent_html .JointSession li {
      padding: 10px 5px;
      background: #3cbaff;
      color: #fff;
      cursor: pointer;
      border: 1px dashed #fff;
    }
    .billContent_html .Password {
      overflow: hidden;
      letter-spacing: 1px !important;
    }
    .billContent_html .Password p {
      font-size: 12px;
      position: relative !important;
    }
    .billContent_html .one {
      position: absolute;
      width: 150px;
      height: 20px;
      // cursor: move;
      top: 10px;
      left: 10px;
      border: 0.4px dashed #000;
    }
    .billContent_html .one p {
      width: 100%;
      height: 100%;
      border: none;
      position: absolute;
      background: transparent;
      text-align: left;
      font-weight: 400;
      text-decoration: none;
      font-style: normal;
    }
    .billContent_html .one .input {
      width: 100%;
      height: 100%;
      border: none;
      position: absolute;
      background: transparent;
      text-align: left;
      font-weight: 400;
      text-decoration: none;
      font-style: normal;
    }
    .billContent_html .one .input.active {
      border: 1px solid red;
    }
    .billContent_html .one .input.active2 {
      border: 1px solid #6490ed;
    }
    .billContent_html .one .span {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 10px;
      height: 10px;
      background: #000;
      // cursor: nw-resize;
    }
    .billContent_html .one textarea {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      line-height: initial;
    }
    .billContent_html .svg1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .jietuDiv table tr td {
      position: relative;
    }
    .jietuDiv table tr td input {
      width: 100%;
    }
    .jietuDiv table tr td input[type="radio"],
    .jietuDiv table tr td input[type="checkbox"] {
      width: auto;
      display: block;
    }
    .jietuDiv .Password {
      overflow: hidden;
    }
    .jietuDiv .Password p {
      position: relative !important;
    }
    .jietuDiv .Textarea p {
      line-height: initial;
      white-space: break-spaces !important;
    }
    .jietuDiv .one {
      position: absolute;
      width: 150px;
      height: 20px;
      // cursor: move;
      top: 10px;
      left: 10px;
      border: 0.4px dashed #000;
    }
    .jietuDiv .one p {
      width: 100%;
      height: 100%;
      border: none;
      position: absolute;
      background: transparent;
      text-align: left;
      font-weight: 400;
      text-decoration: none;
      font-style: normal;
      white-space: nowrap;
    }
    .jietuDiv .one .input {
      width: 100%;
      height: 100%;
      border: none;
      position: absolute;
      background: transparent;
      text-align: left;
      font-weight: 400;
      text-decoration: none;
      font-style: normal;
    }
    .jietuDiv .one .span {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 10px;
      height: 10px;
      background: #000;
      cursor: nw-resize;
    }
    .jietuDiv .one textarea {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      line-height: initial;
    }
    .jietuDiv .svg1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .qyInfoModal ul {
      text-align: center;
      padding: 10px 20px;
    }
    .qyInfoModal ul li {
      height: 35px;
      line-height: 35px;
      border-bottom: 1px solid #ddd;
      color: #666;
      cursor: pointer;
    }
    .qyInfoModal ul li:hover {
      color: #3cbaff;
    }
    .one:hover .qiyeInfoBtn {
      display: block;
    }
    .one:hover .XFInfoBtn {
      display: block;
    }
    .qiyeInfoBtn {
      display: none;
      position: absolute;
      right: 4px;
      top: 0;
      height: 100%;
      cursor: pointer;
    }
    .XFInfoBtn {
      display: none;
      position: absolute;
      right: 4px;
      top: 0;
      height: 100%;
      cursor: pointer;
    }
    .xfInfoModal ul {
      text-align: center;
      padding: 10px 20px;
    }
    .xfInfoModal ul li {
      height: 35px;
      line-height: 35px;
      border-bottom: 1px solid #ddd;
      color: #666;
      cursor: pointer;
    }
    .xfInfoModal ul li:hover {
      color: #3cbaff;
    }
  }

  // 资金申请表
  :deep(.invoice-wrap-e94423edab19469595fe2cd72127c798) {
    .billContent_html {
      .seal {
        display: none;
      }
    }
  }

  // 现金交款单
  :deep(.invoice-wrap-c8a1be6de92546b884895e820d4e679c) {
    .billContent_html {
      .JointSession {
        .JointSessionItem {
          background-color: #cccccc;

          &.active {
            background-color: #3cbaff;
          }
        }
      }
    }
  }

  // input样式
  @mixin inputStyle($start) {
    .billContent_html {
      $start-number: $start;
      $group-interval: 7;
      $total-groups: 21;

      @for $i from 1 through $total-groups {
        $base: $start-number + ($i - 1) * $group-interval;

        @for $j from 0 through 2 {
          $num: $base + $j;

          .one:nth-of-type(#{$num}) {
            input {
              letter-spacing: 4.8px !important;
            }
          }
        }
      }
    }
  }

  // 库存现金日记账
  :deep(.invoice-wrap-9706958b5fd747d3a4b0e2964bb2a328) {
    @include inputStyle(5);
  }

  // 银行存款日记账
  :deep(.invoice-wrap-16df9ed1a2fc44f7bc9fc27acdce069f) {
    @include inputStyle(4);
  }

  :deep(.seal-popup) {
    .seal-popup-content {
      margin-top: 20px;
      max-height: 400px;
      height: 400px;
      overflow: hidden;
      position: relative;

      .seal-list-empty {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 99;
        left: 0;
        top: 0;
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .el-scrollbar {
        padding: 10px;
      }

      .seal-list {
        display: flex;
        flex-wrap: wrap;

        > li {
          width: 25%;
          padding: 5px;
          box-sizing: border-box;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;

          &.is-selected {
            box-shadow: inset 0 0 1px 2px #3f8dfd;
          }

          .el-image {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
      }
    }

    .seal-popup-footer {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  :deep(.draw-tools) {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9;

    .canvas-layer {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 2;
    }

    canvas {
      width: 100%;
      height: 100%;
      cursor: crosshair;
    }
  }

  :deep(.cashier-main) {
    &.toolClick3active {
      .toolClick3 {
        color: #3f8dfd;
      }

      .draw-tools {
        z-index: 2001;
        background-color: rgba(255, 255, 255, 0.5);

        .canvas-layer {
          visibility: hidden;
        }
      }
    }
  }
}
</style>
